const en = {
  moreActions: 'More actions',
  reportComment: 'Report comment',
  reportUser: 'Report user',
  blockUser: 'Block user',
  unblockUser: 'Unblock',
  blockedStatus: 'Blocked by you',
  blockedUsers: 'Blocked users',
  blockedEmpty: 'No blocked users',
  blockQuestion: 'Block this user?',
  blockDescription: 'Their posts will disappear from your feed. Likes and reposts between you will be unavailable.',
  blockConfirm: 'Block',
  cancel: 'Cancel',
  blockError: 'Could not block this user. Try again.',
  unblockError: 'Could not unblock this user. Try again.',
  stateError: 'Could not load blocking status. Try again.',
  interactionBlocked: 'Likes and reposts are unavailable between blocked accounts.',
  repostBlocked: 'This repost is unavailable because of a block. Remove the quote to send your own comment.',
  reportUserTitle: 'Report user',
  reportUserUnavailable: 'This user cannot be reported.',
  reportUserBack: 'Back to profile',
  blockedSearchEmpty: 'No blocked users match this search.',
  blockedListError: 'Could not load blocked users.',
};

const ru = {
  moreActions: 'Другие действия',
  reportComment: 'Пожаловаться на комментарий',
  reportUser: 'Пожаловаться на пользователя',
  blockUser: 'Заблокировать пользователя',
  unblockUser: 'Разблокировать',
  blockedStatus: 'Заблокирован вами',
  blockedUsers: 'Заблокированные пользователи',
  blockedEmpty: 'Нет заблокированных пользователей',
  blockQuestion: 'Заблокировать пользователя?',
  blockDescription: 'Публикации исчезнут из вашей ленты. Лайки и репосты между вами будут недоступны.',
  blockConfirm: 'Заблокировать',
  cancel: 'Отмена',
  blockError: 'Не удалось заблокировать пользователя. Попробуйте ещё раз.',
  unblockError: 'Не удалось разблокировать пользователя. Попробуйте ещё раз.',
  stateError: 'Не удалось загрузить статус блокировки. Попробуйте ещё раз.',
  interactionBlocked: 'Лайки и репосты между заблокированными аккаунтами недоступны.',
  repostBlocked: 'Репост недоступен из-за блокировки. Удалите цитату, чтобы отправить свой комментарий.',
  reportUserTitle: 'Жалоба на пользователя',
  reportUserUnavailable: 'На этого пользователя нельзя пожаловаться.',
  reportUserBack: 'Вернуться в профиль',
  blockedSearchEmpty: 'По запросу не найдено заблокированных пользователей.',
  blockedListError: 'Не удалось загрузить заблокированных пользователей.',
};

const zh = {
  moreActions: '更多操作',
  reportComment: '举报评论',
  reportUser: '举报用户',
  blockUser: '屏蔽用户',
  unblockUser: '取消屏蔽',
  blockedStatus: '已被你屏蔽',
  blockedUsers: '已屏蔽的用户',
  blockedEmpty: '暂无已屏蔽的用户',
  blockQuestion: '屏蔽此用户？',
  blockDescription: '对方的帖子将不再出现在你的动态中。你们将无法互相点赞或转发。',
  blockConfirm: '屏蔽',
  cancel: '取消',
  blockError: '无法屏蔽此用户，请重试。',
  unblockError: '无法取消屏蔽此用户，请重试。',
  stateError: '无法加载屏蔽状态，请重试。',
  interactionBlocked: '存在屏蔽关系的账号之间无法互相点赞或转发。',
  repostBlocked: '由于存在屏蔽关系，无法转发此内容。请移除引用后再发送自己的评论。',
  reportUserTitle: '举报用户',
  reportUserUnavailable: '无法举报此用户。',
  reportUserBack: '返回个人主页',
  blockedSearchEmpty: '未找到符合搜索条件的已屏蔽用户。',
  blockedListError: '无法加载已屏蔽的用户。',
};

const es = {
  moreActions: 'Más opciones',
  reportComment: 'Denunciar comentario',
  reportUser: 'Denunciar usuario',
  blockUser: 'Bloquear usuario',
  unblockUser: 'Desbloquear',
  blockedStatus: 'Bloqueado por ti',
  blockedUsers: 'Usuarios bloqueados',
  blockedEmpty: 'No hay usuarios bloqueados',
  blockQuestion: '¿Bloquear a este usuario?',
  blockDescription: 'Sus publicaciones desaparecerán de tu feed. No podrán dar Me gusta ni republicar las publicaciones del otro.',
  blockConfirm: 'Bloquear',
  cancel: 'Cancelar',
  blockError: 'No se pudo bloquear a este usuario. Inténtalo de nuevo.',
  unblockError: 'No se pudo desbloquear a este usuario. Inténtalo de nuevo.',
  stateError: 'No se pudo cargar el estado de bloqueo. Inténtalo de nuevo.',
  interactionBlocked: 'Las cuentas bloqueadas no pueden darse Me gusta ni republicar contenido entre sí.',
  repostBlocked: 'No se puede republicar este contenido debido a un bloqueo. Elimina la cita para enviar tu propio comentario.',
  reportUserTitle: 'Denunciar usuario',
  reportUserUnavailable: 'No se puede denunciar a este usuario.',
  reportUserBack: 'Volver al perfil',
  blockedSearchEmpty: 'No hay usuarios bloqueados que coincidan con esta búsqueda.',
  blockedListError: 'No se pudieron cargar los usuarios bloqueados.',
};

const pt = {
  moreActions: 'Mais opções',
  reportComment: 'Denunciar comentário',
  reportUser: 'Denunciar usuário',
  blockUser: 'Bloquear usuário',
  unblockUser: 'Desbloquear',
  blockedStatus: 'Bloqueado por você',
  blockedUsers: 'Usuários bloqueados',
  blockedEmpty: 'Nenhum usuário bloqueado',
  blockQuestion: 'Bloquear este usuário?',
  blockDescription: 'As publicações desse usuário desaparecerão do seu feed. Vocês não poderão curtir nem republicar o conteúdo um do outro.',
  blockConfirm: 'Bloquear',
  cancel: 'Cancelar',
  blockError: 'Não foi possível bloquear este usuário. Tente novamente.',
  unblockError: 'Não foi possível desbloquear este usuário. Tente novamente.',
  stateError: 'Não foi possível carregar o status de bloqueio. Tente novamente.',
  interactionBlocked: 'Contas bloqueadas não podem curtir nem republicar o conteúdo uma da outra.',
  repostBlocked: 'Não é possível republicar este conteúdo devido a um bloqueio. Remova a citação para enviar seu próprio comentário.',
  reportUserTitle: 'Denunciar usuário',
  reportUserUnavailable: 'Não é possível denunciar este usuário.',
  reportUserBack: 'Voltar ao perfil',
  blockedSearchEmpty: 'Nenhum usuário bloqueado corresponde a esta busca.',
  blockedListError: 'Não foi possível carregar os usuários bloqueados.',
};

const ja = {
  moreActions: 'その他の操作',
  reportComment: 'コメントを報告',
  reportUser: 'ユーザーを報告',
  blockUser: 'ユーザーをブロック',
  unblockUser: 'ブロックを解除',
  blockedStatus: 'ブロック中',
  blockedUsers: 'ブロック中のユーザー',
  blockedEmpty: 'ブロック中のユーザーはいません',
  blockQuestion: 'このユーザーをブロックしますか？',
  blockDescription: 'このユーザーの投稿はあなたのフィードに表示されなくなります。お互いの投稿への「いいね」やリポストはできなくなります。',
  blockConfirm: 'ブロック',
  cancel: 'キャンセル',
  blockError: 'このユーザーをブロックできませんでした。もう一度お試しください。',
  unblockError: 'このユーザーのブロックを解除できませんでした。もう一度お試しください。',
  stateError: 'ブロック状態を読み込めませんでした。もう一度お試しください。',
  interactionBlocked: 'ブロック関係にあるアカウント同士では「いいね」やリポストはできません。',
  repostBlocked: 'ブロックにより、この内容はリポストできません。引用を削除すると、自分のコメントを送信できます。',
  reportUserTitle: 'ユーザーを報告',
  reportUserUnavailable: 'このユーザーは報告できません。',
  reportUserBack: 'プロフィールに戻る',
  blockedSearchEmpty: '検索条件に一致するブロック中のユーザーはいません。',
  blockedListError: 'ブロック中のユーザーを読み込めませんでした。',
};

const tr = {
  moreActions: 'Diğer işlemler',
  reportComment: 'Yorumu şikâyet et',
  reportUser: 'Kullanıcıyı şikâyet et',
  blockUser: 'Kullanıcıyı engelle',
  unblockUser: 'Engeli kaldır',
  blockedStatus: 'Engellediniz',
  blockedUsers: 'Engellenen kullanıcılar',
  blockedEmpty: 'Engellenen kullanıcı yok',
  blockQuestion: 'Bu kullanıcıyı engellemek istiyor musunuz?',
  blockDescription: 'Bu kullanıcının gönderileri akışınızdan kaldırılacak. Birbirinizin gönderilerini beğenemeyecek veya yeniden paylaşamayacaksınız.',
  blockConfirm: 'Engelle',
  cancel: 'İptal',
  blockError: 'Bu kullanıcı engellenemedi. Tekrar deneyin.',
  unblockError: 'Bu kullanıcının engeli kaldırılamadı. Tekrar deneyin.',
  stateError: 'Engelleme durumu yüklenemedi. Tekrar deneyin.',
  interactionBlocked: 'Aralarında engelleme bulunan hesaplar birbirlerinin gönderilerini beğenemez veya yeniden paylaşamaz.',
  repostBlocked: 'Engelleme nedeniyle bu içerik yeniden paylaşılamıyor. Kendi yorumunuzu göndermek için alıntıyı kaldırın.',
  reportUserTitle: 'Kullanıcıyı şikâyet et',
  reportUserUnavailable: 'Bu kullanıcı şikâyet edilemiyor.',
  reportUserBack: 'Profile dön',
  blockedSearchEmpty: 'Aramanızla eşleşen engellenmiş kullanıcı yok.',
  blockedListError: 'Engellenen kullanıcılar yüklenemedi.',
};

const ko = {
  moreActions: '더보기',
  reportComment: '댓글 신고',
  reportUser: '사용자 신고',
  blockUser: '사용자 차단',
  unblockUser: '차단 해제',
  blockedStatus: '내가 차단한 사용자',
  blockedUsers: '차단한 사용자',
  blockedEmpty: '차단한 사용자가 없습니다',
  blockQuestion: '이 사용자를 차단할까요?',
  blockDescription: '이 사용자의 게시물이 내 피드에서 사라집니다. 서로의 게시물에 좋아요를 누르거나 리포스트할 수 없게 됩니다.',
  blockConfirm: '차단',
  cancel: '취소',
  blockError: '이 사용자를 차단하지 못했습니다. 다시 시도해 주세요.',
  unblockError: '이 사용자의 차단을 해제하지 못했습니다. 다시 시도해 주세요.',
  stateError: '차단 상태를 불러오지 못했습니다. 다시 시도해 주세요.',
  interactionBlocked: '차단 관계인 계정끼리는 좋아요와 리포스트를 사용할 수 없습니다.',
  repostBlocked: '차단으로 인해 이 게시물을 리포스트할 수 없습니다. 인용문을 삭제한 뒤 내 댓글을 보내 주세요.',
  reportUserTitle: '사용자 신고',
  reportUserUnavailable: '이 사용자를 신고할 수 없습니다.',
  reportUserBack: '프로필로 돌아가기',
  blockedSearchEmpty: '검색어와 일치하는 차단된 사용자가 없습니다.',
  blockedListError: '차단한 사용자를 불러오지 못했습니다.',
};

const fr = {
  moreActions: 'Autres actions',
  reportComment: 'Signaler le commentaire',
  reportUser: 'Signaler l’utilisateur',
  blockUser: 'Bloquer l’utilisateur',
  unblockUser: 'Débloquer',
  blockedStatus: 'Vous avez bloqué ce compte',
  blockedUsers: 'Utilisateurs bloqués',
  blockedEmpty: 'Aucun utilisateur bloqué',
  blockQuestion: 'Bloquer cet utilisateur ?',
  blockDescription: 'Ses publications disparaîtront de votre fil. Vous ne pourrez plus aimer ni republier les publications l’un de l’autre.',
  blockConfirm: 'Bloquer',
  cancel: 'Annuler',
  blockError: 'Impossible de bloquer cet utilisateur. Réessayez.',
  unblockError: 'Impossible de débloquer cet utilisateur. Réessayez.',
  stateError: 'Impossible de charger le statut du blocage. Réessayez.',
  interactionBlocked: 'Les comptes bloqués ne peuvent pas aimer ni republier les publications de l’autre.',
  repostBlocked: 'Ce contenu ne peut pas être republié en raison d’un blocage. Retirez la citation pour envoyer votre propre commentaire.',
  reportUserTitle: 'Signaler l’utilisateur',
  reportUserUnavailable: 'Cet utilisateur ne peut pas être signalé.',
  reportUserBack: 'Retour au profil',
  blockedSearchEmpty: 'Aucun utilisateur bloqué ne correspond à cette recherche.',
  blockedListError: 'Impossible de charger les utilisateurs bloqués.',
};

const de = {
  moreActions: 'Weitere Aktionen',
  reportComment: 'Kommentar melden',
  reportUser: 'Nutzer melden',
  blockUser: 'Nutzer blockieren',
  unblockUser: 'Blockierung aufheben',
  blockedStatus: 'Von dir blockiert',
  blockedUsers: 'Blockierte Nutzer',
  blockedEmpty: 'Keine blockierten Nutzer',
  blockQuestion: 'Diesen Nutzer blockieren?',
  blockDescription: 'Die Beiträge dieses Nutzers verschwinden aus deinem Feed. Ihr könnt die Beiträge des anderen nicht mehr liken oder reposten.',
  blockConfirm: 'Blockieren',
  cancel: 'Abbrechen',
  blockError: 'Dieser Nutzer konnte nicht blockiert werden. Versuche es erneut.',
  unblockError: 'Die Blockierung dieses Nutzers konnte nicht aufgehoben werden. Versuche es erneut.',
  stateError: 'Der Blockierungsstatus konnte nicht geladen werden. Versuche es erneut.',
  interactionBlocked: 'Blockierte Konten können die Beiträge des anderen nicht liken oder reposten.',
  repostBlocked: 'Dieser Repost ist wegen einer Blockierung nicht verfügbar. Entferne das Zitat, um deinen eigenen Kommentar zu senden.',
  reportUserTitle: 'Nutzer melden',
  reportUserUnavailable: 'Dieser Nutzer kann nicht gemeldet werden.',
  reportUserBack: 'Zurück zum Profil',
  blockedSearchEmpty: 'Keine blockierten Nutzer für diese Suche gefunden.',
  blockedListError: 'Blockierte Nutzer konnten nicht geladen werden.',
};

const it = {
  moreActions: 'Altre azioni',
  reportComment: 'Segnala commento',
  reportUser: 'Segnala utente',
  blockUser: 'Blocca utente',
  unblockUser: 'Sblocca',
  blockedStatus: 'Bloccato da te',
  blockedUsers: 'Utenti bloccati',
  blockedEmpty: 'Nessun utente bloccato',
  blockQuestion: 'Bloccare questo utente?',
  blockDescription: 'I suoi post scompariranno dal tuo feed. Non potrete mettere Mi piace ai post dell’altro né ripubblicarli.',
  blockConfirm: 'Blocca',
  cancel: 'Annulla',
  blockError: 'Impossibile bloccare questo utente. Riprova.',
  unblockError: 'Impossibile sbloccare questo utente. Riprova.',
  stateError: 'Impossibile caricare lo stato del blocco. Riprova.',
  interactionBlocked: 'Gli account bloccati non possono mettere Mi piace ai post dell’altro né ripubblicarli.',
  repostBlocked: 'Non puoi ripubblicare questo contenuto a causa di un blocco. Rimuovi la citazione per inviare il tuo commento.',
  reportUserTitle: 'Segnala utente',
  reportUserUnavailable: 'Non è possibile segnalare questo utente.',
  reportUserBack: 'Torna al profilo',
  blockedSearchEmpty: 'Nessun utente bloccato corrisponde alla ricerca.',
  blockedListError: 'Impossibile caricare gli utenti bloccati.',
};

const hi = {
  moreActions: 'अन्य विकल्प',
  reportComment: 'कमेंट की रिपोर्ट करें',
  reportUser: 'यूज़र की रिपोर्ट करें',
  blockUser: 'यूज़र को ब्लॉक करें',
  unblockUser: 'अनब्लॉक करें',
  blockedStatus: 'आपने ब्लॉक किया है',
  blockedUsers: 'ब्लॉक किए गए यूज़र',
  blockedEmpty: 'कोई यूज़र ब्लॉक नहीं है',
  blockQuestion: 'इस यूज़र को ब्लॉक करें?',
  blockDescription: 'इस यूज़र की पोस्ट आपकी फ़ीड से हट जाएँगी। आप एक-दूसरे की पोस्ट लाइक या रीपोस्ट नहीं कर पाएँगे।',
  blockConfirm: 'ब्लॉक करें',
  cancel: 'रद्द करें',
  blockError: 'इस यूज़र को ब्लॉक नहीं किया जा सका। फिर से कोशिश करें।',
  unblockError: 'इस यूज़र को अनब्लॉक नहीं किया जा सका। फिर से कोशिश करें।',
  stateError: 'ब्लॉक की स्थिति लोड नहीं हो सकी। फिर से कोशिश करें।',
  interactionBlocked: 'ब्लॉक किए गए अकाउंट एक-दूसरे की पोस्ट लाइक या रीपोस्ट नहीं कर सकते।',
  repostBlocked: 'ब्लॉक होने की वजह से यह रीपोस्ट उपलब्ध नहीं है। अपना कमेंट भेजने के लिए उद्धरण हटाएँ।',
  reportUserTitle: 'यूज़र की रिपोर्ट करें',
  reportUserUnavailable: 'इस यूज़र की रिपोर्ट नहीं की जा सकती।',
  reportUserBack: 'प्रोफ़ाइल पर वापस जाएँ',
  blockedSearchEmpty: 'इस खोज से मेल खाने वाला कोई ब्लॉक किया गया यूज़र नहीं मिला।',
  blockedListError: 'ब्लॉक किए गए यूज़र लोड नहीं हो सके।',
};

const translations = { en, ru, zh, es, pt, ja, tr, ko, fr, de, it, hi };
export default translations;
